import { Provider } from "jotai";
import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";

import {
  DiningBookingWizardQueryRenderer,
  DiningBookingWizardQueryRendererQueryString,
} from "./components/DiningBookingWizardQueryRenderer/DiningBookingWizardQueryRenderer";
import { DiningBookingWizardQueryRendererQuery } from "./components/DiningBookingWizardQueryRenderer/__generated__/DiningBookingWizardQueryRendererQuery.graphql";

type DiningBookingWizardProps = {
  isOpen: boolean;
  onClose: () => void;
  reservationHoldId: string | null;
  membershipTypeId: string | null;
  currentPatronId: string | null;
  clubSlug: string;
  facilityId?: string;
};

export const DiningBookingWizard = (props: DiningBookingWizardProps) => {
  const { isOpen, onClose } = props;
  return (
    <StandardModal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton={true}
      disableContentScroll={true}
      content={<DiningBookingWizardContent {...props} />}
    />
  );
};

type DiningBookingWizardContentProps = DiningBookingWizardProps;

const DiningBookingWizardContent = ({
  isOpen,
  reservationHoldId,
  onClose,
  currentPatronId,
}: DiningBookingWizardContentProps) => {
  // Lesson booking query loader
  const [queryRef, loadQuery] =
    useQueryLoader<DiningBookingWizardQueryRendererQuery>(
      DiningBookingWizardQueryRendererQueryString
    );

  useEffect(() => {
    if (isOpen && reservationHoldId && currentPatronId) {
      // Load lesson booking query
      loadQuery(
        {
          reservationHoldId,
        },
        { fetchPolicy: "network-only" }
      );
    }
  }, [isOpen, loadQuery, reservationHoldId, currentPatronId]);

  return (
    <Provider>
      <Suspense fallback={null}>
        {queryRef && currentPatronId ? (
          <DiningBookingWizardQueryRenderer
            queryRef={queryRef}
            onClose={onClose}
            ownerId={currentPatronId}
          />
        ) : null}
      </Suspense>
    </Provider>
  );
};
